import { sendEvent } from '@/web3-server/web3/handler/sendEvent';
import { getSendOptions } from '@/web3-server/web3/handler/get-send-options';
export default function withdrawBoosting(request, strategyContract, amountWei, supportEIP1559) {
    const { web3 } = request;
    const storageContract = new web3.eth.Contract(strategyContract.abi, strategyContract.address);
    getSendOptions(request, { supportEIP1559 }).then((sendOptions) => {
        sendEvent(request, storageContract.methods.withdrawBLID(amountWei.toFixed()).send(sendOptions));
    });
}
